<script setup>
defineProps({
  title: {
    type: String,
    required: true,
  },
})
</script>

<template>
  <header
    class="flex w-full flex-col items-center justify-center bg-primary px-6 py-20"
  >
    <h1
      class="text-center font-heading text-6xl font-black uppercase text-secondary sm:text-7xl"
    >
      {{ title }}
    </h1>

    <slot />
  </header>
</template>
